<template>
  <span />
</template>

<script>
import { NOTIFICATIONS_TO_ROUTES } from '@/app/data/notifications_routes';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NotificationsRedirect',

  async mounted() {
    const { subdomain, profile_type, profile_id, notification_id } = this.$route.params;
    // old notification emails (with client_id) are incompatible: redirect to root
    // oxlint-disable-next-line no-return-assign
    if (/^\d+$/.test(subdomain)) return (window.location.href = '/');

    const response = await this.FETCH_NOTIFICATION({
      id: notification_id,
      profile_id,
      profile_type,
    });
    const notification = _.chain(response).get('Notification', {}).values().first().value();
    const current_user = _.chain(response).get('User', {}).values().first().value();

    // typically a 404 error, related handler will do redirect
    if (_.isNull(notification) || _.isUndefined(notification)) return;

    const notificationRoute = NOTIFICATIONS_TO_ROUTES[notification.attributes.key];
    const { parameters, project_id } = notification.attributes;
    const params = _.pickBy({
      ...parameters,
      project_id,
      subdomain,
    });
    // add (potential) impersonation meta attributes in sessionStorage, based on route params
    const query =
      notification.attributes.target_user_id === current_user.id
        ? {}
        : { _profile_type: profile_type, _profile_id: profile_id };
    const route_data = this.$router.resolve({
      name: notificationRoute,
      params,
      query,
    });
    window.location.href = route_data.href;
  },

  methods: {
    ...mapActions(['FETCH_NOTIFICATION']),
  },
};
</script>
